module.exports = __webpack_public_path__ + "static/resume-b1ed1e1665f0d06a71103cca5eefe098.pdf";